export default "__VITE_ASSET__80e3ccd7__"